"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindMiddleware = void 0;
const redux_1 = require("redux");
const redux_devtools_extension_1 = require("redux-devtools-extension");
const bindMiddleware = (middleware) => {
    // const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    return (0, redux_devtools_extension_1.composeWithDevTools)((0, redux_1.applyMiddleware)(...middleware));
    // if (currentEnv !== 'prod') {
    // }
    // return applyMiddleware(...middleware);
};
exports.bindMiddleware = bindMiddleware;
//# sourceMappingURL=index.js.map